import { type ComponentProps, memo, type ReactNode } from 'react';

import { tailwindVariants } from '@air/utils-tailwind';

export const breadcrumbsButton = tailwindVariants({
  base: 'flex min-w-0 items-center rounded-4 font-medium text-grey-9 outline-none hover:bg-grey-4 hover:text-grey-11 focus-visible:ring-2 focus-visible:ring-blue-9 active:bg-grey-4 active:text-grey-12 ui2:text-grey-11 ui2:hover:bg-grey-3 ui2:active:bg-grey-4',
  defaultVariants: {
    size: 'small',
  },
  variants: {
    size: {
      large: 'h-10 gap-2 px-4',
      medium: 'h-8 gap-2 px-3',
      small: 'h-6 gap-1 px-1',
    },
  },
});

export type BreadcrumbsButtonProps = Omit<ComponentProps<'button'>, 'prefix'> & {
  onClick: () => void;
  prefix?: ReactNode;
  suffix?: ReactNode;
};

export const BreadcrumbsButton = memo(
  ({ children, className, prefix, suffix, ...restOfProps }: BreadcrumbsButtonProps) => {
    return (
      <button className={breadcrumbsButton({ class: className })} data-testid="BREADCRUMBS_BUTTON" {...restOfProps}>
        {!!prefix && <div className="shrink-0">{prefix}</div>}

        <div className="truncate">{children}</div>

        {!!suffix && <div className="shrink-0">{suffix}</div>}
      </button>
    );
  },
);

BreadcrumbsButton.displayName = 'BreadcrumbsButton';
